import { render, staticRenderFns } from "./otherDocument.vue?vue&type=template&id=8457faba&scoped=true"
import script from "./otherDocument.vue?vue&type=script&lang=js"
export * from "./otherDocument.vue?vue&type=script&lang=js"
import style0 from "./otherDocument.vue?vue&type=style&index=0&id=8457faba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8457faba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8457faba')) {
      api.createRecord('8457faba', component.options)
    } else {
      api.reload('8457faba', component.options)
    }
    module.hot.accept("./otherDocument.vue?vue&type=template&id=8457faba&scoped=true", function () {
      api.rerender('8457faba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appManage/poManage/otherDocument.vue"
export default component.exports